import { useToast } from '@/view/components/ui/use-toast'
import { ProposalData } from '..'

interface useProposalSuccessModalProps {
  proposalData: ProposalData
}

export default function useProposalSuccessModal({
  proposalData,
}: useProposalSuccessModalProps) {
  const { toast } = useToast()

  const copyWhatsAppLink = () => {
    if (!proposalData?.authorizationLink) {
      toast({
        title: 'Não foi possível copiar o link.',
        description: 'A URL da proposta ainda não está disponível.',
        variant: 'destructive',
      })
      return
    }

    navigator.clipboard.writeText(proposalData.authorizationLink)

    toast({
      title: 'Link copiado com sucesso!',
    })
  }

  return { copyWhatsAppLink }
}
